export default __webpack_public_path__ + "static/media/delt.426afaad.svg";